import type { HTMLAttributes } from 'preact/compat';
import { getImageCdnRootPath } from 'utils/cdn';

type Props = HTMLAttributes<HTMLImageElement> & {
	className?: string;
	src: string;
	alt: string;
	width?: number;
	height?: number;
};

export function onImageErrorHandler(src: string = '') {
	return ({ target }: Event) => {
		if (target instanceof HTMLImageElement && target.src !== src) {
			target.src = src;
		} else {
			throw new Error(`Image not found: ${src}`);
		}
	};
}

export function Image({ className, src, alt, ...rest }: Props) {
	return (
		<img
			{...rest}
			className={className}
			// #if [DEBUG_LOCAL=1]
			src={src}
			// #else
			// @ts-expect-error
			src={getImageCdnRootPath(src)}
			// #endif
			alt={alt}
			onError={onImageErrorHandler(src)}
		/>
	);
}
